import { ref, watch, onMounted } from "@vue/composition-api";

export default function useDotplotChartDataSet(dataRef) {
  const dotplotChartDataSet = ref([]);

  const updateDataSet = () => {
    if (!dataRef?.value) {
      dotplotChartDataSet.value = [];
      return;
    }

    const convertedData = [];

    for (const group of dataRef.value) {
      for (const dot of group.dots) {
        if (dot.y != null) {
          convertedData.push({
            x: group.x,
            ...dot,
          });
        }
      }
    }

    dotplotChartDataSet.value = convertedData;
  };

  watch(dataRef, updateDataSet);

  onMounted(updateDataSet);

  return { dotplotChartDataSet };
}
